const _ = require('lib/underscore')
const InputView = require('./input_view')


const InputTextareaView = InputView.extend({

    tagName: 'textarea',
    template: _.template('{{ data.value }}'),

    attribute_keys: [
        'id',
        'name',
        'rows',
        'cols',
        'placeholder',
        'maxlength',
        'disabled',
    ],

    triggers: {
        'change': 'input:change',
        'keydown': {
            event: 'input:change',
            preventDefault: false,
            stopPropagation: false,
        },
        'keyup': {
            event: 'input:change',
            preventDefault: false,
            stopPropagation: false,
        },
    },

})

module.exports = InputTextareaView
